export default __webpack_public_path__ + "static/media/pic3.1611b9d0.jpg";